import React from 'react';
import { useTranslation } from 'react-i18next';
import { getImmediateStartName } from '@common/components/Job/EnhanceJob/components/getImmediateStartName';
import { useRedirect } from '@common/hooks/useRedirect';
import { AD_TYPE } from '@seek/je-shared-data';
import { SupportedCountryCode } from '@seek/je-shared-data/lib/types/brand';
import { Badge } from '@components/Badge';
import { PlusAdInfoWithUpgradeButton } from '../AdInfo';

type PlusAdCardProps = {
  adDuration?: number;
  price: React.ReactNode;
  countryCode: string;
  jobId: string;
  campaignId: string;
};

export const UpsellPlusAdCard = (props: PlusAdCardProps) => {
  const { t } = useTranslation();
  const { adDuration, price, countryCode, jobId, campaignId } = props;
  const { redirect } = useRedirect();

  const immediateStartText = t(
    getImmediateStartName(countryCode as SupportedCountryCode)
  );

  return (
    <div className={'flex flex-col p-md border'}>
      <div className="flex flex-row gap-md w-full justify-end min-h-10">
        <Badge tone="promo">{t('upgradeJobForm.recommended')}</Badge>
      </div>

      <PlusAdInfoWithUpgradeButton
        immediateStartText={immediateStartText}
        adDuration={adDuration}
        price={price}
        onUpgradeButtonClicked={redirect(
          `/${countryCode}/jobs/${jobId}/enhance-job?campaign=${campaignId}&adType=${AD_TYPE.PLUS}`
        )}
      />
    </div>
  );
};
